import { Outlet, Link } from "react-router-dom";

const AdminLayout = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <aside style={styles.sidebar}>
        <h2 style={styles.logo}>ADMIN</h2>

        <nav style={styles.nav}>
          <Link to="/admin">Dashboard</Link>
          <Link to="/admin/products">Products</Link>
          <Link to="/admin/orders">Orders</Link>
        </nav>
      </aside>

      {/* Content */}
      <main style={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};

const styles = {
  sidebar: {
    width: "220px",
    background: "#111",
    color: "#fff",
    padding: "24px",
  },
  logo: {
    marginBottom: "30px",
  },
  nav: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },
  content: {
    flex: 1,
    background: "#f4f6f8",
    padding: "30px",
  },
};

export default AdminLayout;
